var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2686 2.36387C15.1984 1.43405 16.706 1.43405 17.6358 2.36387C18.5656 3.29369 18.5656 4.80122 17.6358 5.73104L16.6919 6.67496L13.3247 3.30779L14.2686 2.36387Z",
    fill: "#4B4F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6411 4.99138L1.6665 14.966V18.3332H5.03367L15.0083 8.35855L11.6411 4.99138Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.72dbc42e3496cf50e0565e649dc1a550.svg";
export { ForwardRef as ReactComponent };